<template>
  <router-link
               @mouseenter="focusId = item.id"
               @mouseleave="focusId = -1"
               :class="['title-icon-container',
                      { 'active': returnActive(item.name, item.id)}
                     ]"
               :key="item.id"
               :to=" { name: item.name } ">

    <icon-default
        :color="returnActive(item.name, item.id)
            ? 'light'
            : 'white'">
      <component :is="item.icon"/>
    </icon-default>
    <main-title>
      {{ item.text }}
    </main-title>
  </router-link>
</template>

<script>
import IconDefault from "@/components/shared/icons/IconDefault.vue";
import MainTitle from "@/components/shared/text/MainTitle.vue";

export default {
  name: "NavigationTitle",
  components: {MainTitle, IconDefault},
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      focusId: -1
    }
  },
  computed: {
    activeRout() {
      return this.$route.name;
    },
  },
  methods: {
    returnActive(name, id) {
      return this.activeRout?.includes(name) || id === this.focusId
    },
  }
}
</script>

<style scoped lang="scss">

.title-icon-container {
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 16px;

  .main-title-container {
    position: relative;
    transition: all .3s ease;
    color: var(--color-white);

    &:before {
      content: '';
      width: 100%;
      height: 1px;
      background-color: var(--color-white);
      position: absolute;
      left: 0;
      bottom: 0;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform 0.25s;
    }
  }

  &.active {
    .main-title-container {
      color: var(--color-white);
      &:before {
        transform: scaleX(1);
        transform-origin: left;
        transition: transform 0.25s;
      }
    }
  }
}
</style>